import { useIntl } from 'react-intl-next';
import { usePathParam } from 'react-resource-router';

import { messages } from './messages';

/**
 * @returns Platform Team Id in the url.
 */
const useTeamId = (): string => {
	const intlApi = useIntl();
	const [teamId] = usePathParam('teamId');

	if (!teamId) {
		throw new Error(intlApi.formatMessage(messages.teamIdError));
	}

	return teamId;
};

export { useTeamId };
